// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ND-z","hovered":"OD-z","hoverImage":"PD-z","mainImage":"QD-z","imageNoBackground":"RD-z","fullSizeImage":"SD-z"};